
import { defineComponent, ref } from 'vue'
import api from '../../services/fetch'

interface CoefficientData {
  variable: string
  coefficient: number
}

interface ParseResponse {
  tsv: string
  data: CoefficientData[]
}

export default defineComponent({
  name: 'CixDash',
  setup() {
    const formula = ref('')
    const parsedData = ref<CoefficientData[]>([])
    const tsvData = ref('')
    const isLoading = ref(false)
    const error = ref('')

    const parseFormula = async () => {
      if (!formula.value.trim()) return

      isLoading.value = true
      error.value = ''
      parsedData.value = []
      tsvData.value = ''

      try {
        const response = await api.post<ParseResponse>(
            'cix/parse/',
            { formula: formula.value }
        )

        parsedData.value = response.data.data
        tsvData.value = response.data.tsv
      } catch (err: any) {
        if (err.response?.data?.error) {
          error.value = err.response.data.error
        } else {
          error.value = 'An error occurred while parsing the formula'
        }
      } finally {
        isLoading.value = false
      }
    }

    const formatCoefficient = (value: number): string => {
      return value.toFixed(4)
    }

    const copyToClipboard = async () => {
      if (!tsvData.value) return

      try {
        await navigator.clipboard.writeText(tsvData.value)
      } catch (err) {
        // Fallback for older browsers
        const textArea = document.createElement('textarea')
        textArea.value = tsvData.value
        document.body.appendChild(textArea)
        textArea.select()
        document.execCommand('copy')
        document.body.removeChild(textArea)
      }
    }

    return {
      formula,
      parsedData,
      tsvData,
      isLoading,
      error,
      parseFormula,
      formatCoefficient,
      copyToClipboard
    }
  }
})
